(ns hai.tasks.drawer.search-row
  "The row a drawer tab's search opens in: a strip of the drawer's own, between
   the tray and the tabs. Only the list of what the search finds lies over
   anything."
  (:require
   [hai.entity.form :as entity-form]
   [hai.tasks.drawer.parts :as parts]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]
   [reagent.core :as r]))

(def ^:private press-settle-ms 700)

;; In the tray's colour and between the tray's edges, so it reads as the
;; tray's foot. With nothing of the drawer above it — the tray shut — it is
;; the top of the drawer and takes the tray's rounded edge. What the search
;; finds rises over the tray in a plain panel.
(o/defstyled row-frame :div
  {:position "relative"
   :flex "none"
   :padding "2px 10px 10px"
   :background t/--task-drawer-surface
   :border-width "0 1px" :border-style "solid" :border-color t/--property-3}
  [:&:first-child
   {:padding-top "10px"
    :border-top-width "1px"
    :border-radius "16px 16px 0 0"}]
  [parts/results-band
   {:position "absolute" :left "6px" :right "6px" :bottom "calc(100% + 2px)" :z-index "2"
    :margin-bottom "0" :padding "8px"
    :border-width "1px" :border-style "solid" :border-color t/--card-sage-light
    :border-radius "12px"
    :background t/--card-surface}]
  [entity-form/footer {:margin-top "0"}])

(defn component
  "The row of a tab's search, around `content`. `on-press-elsewhere`, if given,
   is called after a press outside the row, once that press has done what it
   does: when its click lands, or shortly after where none comes."
  [{:keys [on-press-elsewhere]} content]
  (r/with-let [!row (atom nil)
               !root (atom nil)
               !waiting (atom nil)
               !on-press-elsewhere (atom nil)
               settle! (fn [& _]
                         (when-let [timer @!waiting]
                           (js/clearTimeout timer)
                           (reset! !waiting nil)
                           (when-let [on-press @!on-press-elsewhere]
                             (on-press))))
               on-pointer-down (fn [^js e]
                                 (when (and @!on-press-elsewhere
                                            (not @!waiting)
                                            (not (.contains ^js @!row (.-target e))))
                                   (reset! !waiting (js/setTimeout settle! press-settle-ms))))
               unwatch! (fn []
                          (when-let [^js root @!root]
                            (.removeEventListener root "pointerdown" on-pointer-down true)
                            (.removeEventListener root "click" settle!))
                          (some-> @!waiting js/clearTimeout)
                          (reset! !root nil)
                          (reset! !waiting nil))
               ;; On the row's own root rather than the document: from inside a
               ;; shadow root, as in the extension, the document is only told
               ;; that the root's host was pressed.
               watch! (fn [^js row]
                        (let [root (.getRootNode row)]
                          (reset! !row row)
                          (reset! !root root)
                          (.addEventListener root "pointerdown" on-pointer-down true)
                          (.addEventListener root "click" settle!)))
               attach! (fn [row]
                         (if row
                           (watch! row)
                           (unwatch!)))]
    (reset! !on-press-elsewhere on-press-elsewhere)
    [row-frame {:ref attach!}
     content]
    (finally
      (unwatch!))))
